import { Box, Grid, Typography } from "@mui/material";
import Image from "next/image";
import UserAddressFormDialog from "@/app/(main)/profile/address/components/UserAddressFromDialog";
import { ReactNode } from "react";

type Props = {
  primary: string;
  secondary: string;
  action?: ReactNode;
  image: string;
};

export default function NotFoundComponent(props: Props) {
  const { primary, secondary, action, image } = props;
  return (
    <>
      <Grid container={true} alignItems={"center"} justifyContent={"center"} spacing={2}>
        <Grid item xs={12} sm={8} md={6} lg={5} xl={4}>
          <Box
            sx={{
              mt: 1,
              width: "100%",
              // height: minHeight,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box sx={{ position: "relative", width: { xs: "40%", sm: "60%", md: '80%' }, aspectRatio: 1, mb: 3 }}>
              <Image src={image} alt={primary} fill style={{ objectFit: "contain" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} justifyContent={"center"} alignItems={"center"} display={"flex"}>
          <Typography variant="h5">{primary}</Typography>
        </Grid>
        {secondary && (
          <Grid item xs={12} justifyContent={"center"} alignItems={"center"} display={"flex"}>
            <Typography variant="body2" textAlign={"center"}>
              {secondary}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} justifyContent={"center"} alignItems={"center"} display={"flex"} mt={1.5}>
          {action}
        </Grid>
      </Grid>
    </>
  );
}
